import { buildOrdenPagoNuevoDoc } from "./ordenPagoPdf";

// El endpoint api/calculadora/calculadoraliquidaciones devuelve los importes
// como texto con formato es-ES ("10.000,00").
const parseMonto = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const numero = Number(String(value).replace(/\./g, "").replace(",", "."));
  return Number.isFinite(numero) ? numero : 0;
};

const formatMonto = (value) =>
  new Intl.NumberFormat("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

const formatPorcentaje = (value) => {
  const porcentaje = String(value ?? "").trim();
  if (!porcentaje) return "";
  return porcentaje.includes("%") ? porcentaje : `${porcentaje}%`;
};

const hoy = () =>
  new Date().toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" });

const CAMPOS_SUMA = [
  "bruto",
  "costoFinanciero",
  "costoPorAnticipo",
  "arancel",
  "ivaArancel",
  "impDebitoCredito",
  "retencionIIBB",
  "retencionGanancia",
  "retencionIVA",
  "retencionTem",
  "totalOP",
];

// Convierte las filas simuladas al mismo formato que usa la orden de pago real
// (comercioData / tipoData), para generar el PDF idéntico al que recibe el aliado.
export const buildOrdenPagoSimulada = (filas = []) => {
  const fecha = hoy();

  const numericas = filas.map((fila) => ({
    esDebito: String(fila.tipoDebCred || "").toLowerCase() === "debito",
    tarjeta: [fila.tarjeta, fila.tipoDebCred].filter(Boolean).join(" "),
    cuotas: fila.cuota ?? "-",
    bruto: parseMonto(fila.montoinicial),
    costoFinanciero: parseMonto(fila.costoTarjeta),
    costoPorAnticipo: parseMonto(fila.costoAnticipo),
    arancel: parseMonto(fila.sumComision),
    ivaArancel: parseMonto(fila.sumIvaComision),
    impDebitoCredito: parseMonto(fila.debcredFinal),
    retencionIIBB: parseMonto(fila.alicuotaFinal),
    retencionGanancia: parseMonto(fila.gananciaFinal),
    retencionIVA: parseMonto(fila.ivaFinal),
    retencionTem: parseMonto(fila.narFinal),
    // El backend ya devuelve en "bruto" el neto final con todos los descuentos.
    totalOP: parseMonto(fila.bruto),
  }));

  const datos = numericas.map((fila) => ({
    terminal: "-",
    nroOperacion: "-",
    fechaOperacion: fecha,
    tarjeta: fila.tarjeta,
    cuotas: fila.cuotas,
    ...Object.fromEntries(CAMPOS_SUMA.map((campo) => [campo, formatMonto(fila[campo])])),
  }));

  const sumas = Object.fromEntries(
    CAMPOS_SUMA.map((campo) => [
      campo,
      formatMonto(numericas.reduce((total, fila) => total + fila[campo], 0)),
    ])
  );
  sumas.retencionTemPct = formatPorcentaje(
    filas.find((fila) => String(fila.tarjeta || "").toLowerCase() === "naranja")?.retencionTem
  );

  const totalDebito = numericas.filter((fila) => fila.esDebito).reduce((t, fila) => t + fila.totalOP, 0);
  const totalCredito = numericas.filter((fila) => !fila.esDebito).reduce((t, fila) => t + fila.totalOP, 0);

  return {
    fechaPago: fecha,
    comercioData: {
      comercio: "Simulacion",
      info: {
        empresa: "Simulación",
        direccion: "-",
        provincia: "-",
        telefono: "-",
        email: "-",
        banco: "-",
        nroCuenta: "-",
      },
    },
    tipoData: {
      tipoTarjeta: "GENERAL",
      acumulados: {
        hoySeAcredita: formatMonto(totalDebito + totalCredito),
        acumulado: formatMonto(totalDebito + totalCredito),
        acumuladoDebito: formatMonto(totalDebito),
        acumuladoCredito: formatMonto(totalCredito),
      },
      datos,
      sumas,
    },
  };
};

export const ORDEN_PAGO_SIMULADA_FILENAME = () =>
  `OrdenPago_Simulacion_${hoy().replace(/\//g, "-")}.pdf`;

export const buildOrdenPagoSimuladaDoc = (filas) => buildOrdenPagoNuevoDoc(buildOrdenPagoSimulada(filas));
